import { render } from "./DemographicItem.vue?vue&type=template&id=52060942&scoped=true"
import script from "./DemographicItem.vue?vue&type=script&lang=js"
export * from "./DemographicItem.vue?vue&type=script&lang=js"

import "./DemographicItem.vue?vue&type=style&index=0&id=52060942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52060942"]])

export default __exports__